import {UserSearchStateCriteria} from 'src/constants';
import {LicenseType} from 'src/openapi/admin/models/LicenseType';

import type {AccountActiveUserCount} from 'src/openapi/admin/models/AccountActiveUserCount';

type UserTypes = {
    [key: string]: {
        tab: string,
        caption: string,
        key: keyof AccountActiveUserCount,
    },
};

export const USER_TYPES_BY_KEYS: {[key: string]: UserSearchStateCriteria} = {
    licensed: UserSearchStateCriteria.LICENSED,
    mobile: UserSearchStateCriteria.MOBILE,
    crmOnly: UserSearchStateCriteria.CRM_ONLY,
    disabled: UserSearchStateCriteria.FREE_NEWSLETTER,
    noAccess: UserSearchStateCriteria.NO_ACCESS,
    creditAlerts: UserSearchStateCriteria.CREDIT_ALERTS_ONLY,
};

export const USER_KEYS_BY_TABS: {[key: string]: string} = {
    'licensed': 'licensed',
    'mobile': 'mobile',
    'crm-only': 'crmOnly',
    'disabled': 'disabled',
    'no-access': 'noAccess',
    'credit-alerts-only': 'creditAlerts',
};

export const USERS_TYPES: UserTypes = {
    [UserSearchStateCriteria.LICENSED]: {
        tab: 'licensed',
        key: 'licensed',
        caption: 'Licensed Enabled Users',
    },
    [UserSearchStateCriteria.MOBILE]: {
        tab: 'mobile',
        key: 'mobile',
        caption: 'Mobile Enabled Users',
    },
    [UserSearchStateCriteria.CRM_ONLY]: {
        tab: 'crm-only',
        key: 'crmOnly',
        caption: 'CRM Enabled Users',
    },
    [UserSearchStateCriteria.FREE_NEWSLETTER]: {
        tab: 'disabled',
        key: 'disabled',
        caption: 'Disabled (Newsletter)',
    },
    [UserSearchStateCriteria.NO_ACCESS]: {
        tab: 'no-access',
        key: 'noAccess',
        caption: 'No Access Empty',
    },
    [UserSearchStateCriteria.CREDIT_ALERTS_ONLY]: {
        tab: 'credit-alerts-only',
        key: 'creditAlerts',
        caption: 'Credit Alerts Enabled Users',
    },
};

export const MAX_CONTRACT_FIELD_VALUE = 99999999;

export const SEATS_RANGE_LICENSES: LicenseType[] = [LicenseType.US, LicenseType.UGP];
